import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  OnInit,
  ViewChild
 } from '@angular/core';
import { FormControl, NumberValueAccessor } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource} from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';

import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { User } from 'src/app/@core/models/infrastructure/User.model';
import { AppService } from 'src/app/@core/services/app/app.service';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import { LdapService } from 'src/app/@core/services/ldap/ldap.service';


@Component({
  selector: 'app-org-table-users-step',
  templateUrl: './org-table-users-step.component.html',
  styleUrls: ['./org-table-users-step.component.scss']
})
export class OrgTableUsersStepComponent implements OnInit, OnChanges {
  MIN_CHARS_SUGGEST = 3;
  selectedNuumas: User[] = [];
  filteredNuumas: Observable<string[]>;
  displayedColumns: string[] = ['name', 'mail', 'group', 'action'];
  dataSource: MatTableDataSource<User>;
  newRole: string = 'user';
  isSelect: boolean;
  nuumaSelect: string;
  disabled: boolean = false;
  counter: number = 20;
  intervalId: any;

  public loading = false;
  public notResults = false;

  userCtrl = new FormControl();

  @Input() organization: Organization;
  @Input() infrastructure: Infrastructure;
  @Input() new: boolean;
  @Input() myForm;
  @ViewChild('adminInput') adminInput: ElementRef<HTMLInputElement>;
  @ViewChild('autoNuumas') matAutocomplete: MatAutocomplete;
  @ViewChild('userInput') userInput: ElementRef<HTMLInputElement>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private readonly ldapService: LdapService,
    public infraService: InfrastructureService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private appService: AppService,
    private readonly router: Router,
    public darkModeService: DarkModeService) {
      this.userCtrl.valueChanges.pipe(
        debounceTime(300)
      ).subscribe((x) => {
        let sbs: Subscription;
        if (x && x.length >= this.MIN_CHARS_SUGGEST) {
          this.loading = true;
          this.notResults = false;
          this.filteredNuumas = this.ldapService.search(x);
          sbs = this.filteredNuumas.subscribe((rsp: string[]) => {
            this.loading = false;
            if (rsp && rsp.length === 0) {
              this.notResults = true;
            }
            sbs.unsubscribe();
          });
        } else {
          this.notResults = false;
          this.loading = false;
          this.filteredNuumas = null;
        }
      });
  }

  ngOnInit(): void {
    this.observerUserInput();
    this.checkAtLeastOneAdmin();
    if (this.new){
      this.newRole = "admin";
    }
  }

  startCounter(): void {
    this.intervalId = setInterval(() => {
      if (this.counter > 0) {
        this.counter--; // Decrementar el contador
      } else {
        clearInterval(this.intervalId); // Detener el contador cuando llega a cero
        this.disabled = false; // Habilitar el botón nuevamente
        this.counter = 20;
      }
    }, 1000); // Contar cada segundo (1000ms)
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }

  addNew(roleSelect: string){
    this.cleanWarmMessages();
    this.newRole = roleSelect;

    // Si ya existía y está marcado para eliminar, se resetea el flag action
    let foundUser = this.selectedNuumas.find(nuuma => nuuma.name == this.userCtrl.value && nuuma.action === "delete");
    if (foundUser) {
      foundUser.action = "";
      let index = this.selectedNuumas.indexOf(foundUser);
      if (index >= 0) {
        this.selectedNuumas.splice(index, 1);
        // Añadimos el usuario en la ultima posición
        this.selectedNuumas.push(foundUser);
      }
    } else {
      // el usuario no se encuentra en ningun grupo
      let user = new User();
      user.name = this.userCtrl.value
      user.mail = ""
      user.role = this.newRole
      user.action = 'add';
      this.selectedNuumas.push(user);
      
      this.isDuplicatedUsersNuuma();

      if (this.organization.isDuplicatedUser){
        const index = this.selectedNuumas.indexOf(user);
        if (index >= 0) {
          this.selectedNuumas.splice(index, 1);
        }
      } else {
        // Si no existia ya en un grupo, lo añadimos
        this.infraService.getEmailUsername(user.name)
        .subscribe(v => {
          // Se solventa error en consola en el caso que el usuario no tenga mail registrado: "Cannot read properties of undefined (reading 'message')"
          // En caso de no tener mail registrado se debe setear a null para que en la vista aparezca el icono.
          if (v) {
            user.mail = v.message;
            if(v.message.includes("3p.mapfre.com")){
              this.snackBar.open("The user" + user.name + " has configured a domain which will be removed", null, { duration: 5000, panelClass: "warning-snackbar"});
            }
          } else {
            user.mail = null;
          }

        });
      }
    }
    
    this.dataSource = new MatTableDataSource(this.selectedNuumas.filter(nuuma => nuuma.action !== "delete")); 
    this.dataSource.paginator = this.paginator;
    setTimeout(() => {
      this.dataSource.paginator.lastPage();
    }, 200)
    
    this.userCtrl.setValue(null);
    this.isSelect = false;
    this.checkAtLeastOneAdmin();
    
   }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.organization ){
      this.getNuumas();
    }
  }

  cleanSuggestions() {
    this.filteredNuumas = new Observable<string[]>();
  }

  remove(nuuma: User): void {
    this.cleanWarmMessages();

    // Si el usuario no está como admin ni como usuario, se elimina de selectedNuuma.
    if (!this.findAdmin(nuuma.name) && !this.findUser(nuuma.name)) {
      let index = this.selectedNuumas.indexOf(nuuma);
      if (index >= 0) {
        this.selectedNuumas.splice(index, 1);
      }
    }

    // Si la acción previa se cambió de role, hay que cambiar el role de nuevo
    if (nuuma.action === 'update') {
      nuuma.role = (nuuma.role === 'admin') ? 'user' : 'admin';
    }

    nuuma.action = 'delete';
    this.dataSource = new MatTableDataSource(this.selectedNuumas.filter(nuuma => nuuma.action !== "delete"));
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator.lastPage();

    this.userCtrl.setValue(null);
    this.checkAtLeastOneAdmin();
  }

  isDuplicatedUsersNuuma() {
    this.organization.isDuplicatedUser = false;

    this.selectedNuumas.forEach((user) => {
      if (!this.organization.isDuplicatedUser){
        const duplicateUsersArray = this.selectedNuumas.filter(nuuma => user.name === nuuma.name);
        this.organization.isDuplicatedUser = duplicateUsersArray.length > 1 ? true : false;
      }
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.nuumaSelect= event.option.value;
    this.isSelect = true;
    this.addNew('admin');
  }

  observerUserInput() {
    this.userCtrl.valueChanges.subscribe(rest => {
      if ( rest === '' || rest !== this.nuumaSelect ){
        this.isSelect = false;
      }
    });
  }

  getNuumas(){
    this.selectedNuumas = [];
    this.organization.isDuplicatedUser = false;

    // Escapamos la gestion del boton update para el caso de creación de org 
    // en la cual no tenemos el objeto infrastructure informado
    if (this.infrastructure) {
      let globalOrg = this.infrastructure.organizations?.find(org => org.name === this.organization.name);
      if (globalOrg.saved) {
        const tiempoTranscurrido: number = Date.now() - globalOrg.saved;
        const segundosTranscurridos: number = Math.ceil(tiempoTranscurrido / 1000); // Convertir a segundos obteniendo parte entera
        if (segundosTranscurridos <= 20) {
          this.organization.admins = globalOrg.admins;
          this.organization.users = globalOrg.users;
          this.disabled = true;
          this.counter = 20 - segundosTranscurridos;
          clearInterval(this.intervalId); 
          this.startCounter();
        }
      }
    }


    if (this.organization.admins !== undefined) {
      this.organization.admins.forEach((element) => {
        const u = new User();
        u.name = element.name;
        u.mail = element.mail;
        u.role = 'admin';
        u.action = '';
        this.selectedNuumas.push(u);
      });
    }

    if (this.organization.users !== undefined){
      this.organization.users.forEach((element) => {
        const u = new User();
        u.name = element.name;
        u.mail = element.mail;
        u.role = 'user';
        u.action = '';
        this.selectedNuumas.push(u);
      });
    }

    this.dataSource = new MatTableDataSource(this.selectedNuumas);
    this.dataSource.paginator = this.paginator;
    this.cleanSuggestions();
    this.checkAtLeastOneAdmin();
  }

  changeRole(user): void {
    this.cleanWarmMessages();

    this.selectedNuumas.forEach((element) => {
      this.markUpdateOrNot(user, element);
    });

    this.checkAtLeastOneAdmin();
    
  }

  markUpdateOrNot(selectedUser, user): void {
    if (user.name == selectedUser.name) {
      if (selectedUser.action === '' || selectedUser.action === undefined) {
        user.action = 'update'; // Marcamos para cambiar de grupo
      } else if (selectedUser.action === 'update') {
        user.action = ''; // Deshacemos el cambio de rol
      }
    }
  }

  findAdmin(name): boolean {
    return this.organization.admins.findIndex( u => u.name === name) >= 0;
  }

  findUser(name): boolean {
    return this.organization.users.findIndex( u => u.name === name) >= 0;
  }

  cleanWarmMessages() {
    this.organization.isDuplicatedUser = false;
  }

  checkAtLeastOneAdmin() {
    if (this.selectedNuumas.filter(u => u.role === 'admin' && u.action !== 'delete').length > 0) {
      this.organization.atLeastOneAdmin = true;
    } else {
      this.organization.atLeastOneAdmin = false;
    }
  }

  checkNuumas() {

    this.selectedNuumas.forEach(nuuma => {
      if (nuuma.action === 'add') {
        nuuma.role === 'user' ? this.organization.users.push(nuuma) : this.organization.admins.push(nuuma);
      }    
      else if (nuuma.action === 'delete') {
        if (nuuma.role === 'user') {
          let user = this.organization.users.find(user => nuuma.name === user.name)
          user.action = 'delete'
        } else {
          let user = this.organization.admins.find(user => nuuma.name === user.name)
          user.action = 'delete'
        }    
      } else if (nuuma.action === 'update') {
        // si se hizo un cambio de role, se actualiza el action en la lista contraria
        if (nuuma.role === 'user') {
          let user = this.organization.admins.find(user => nuuma.name === user.name)
          user.action = 'update'
        } else {
          let user = this.organization.users.find(user => nuuma.name === user.name)
          user.action = 'update'
        }    
      }    
    });
  }

  confirmNewOrg() { 
    const loading = this.appService.openLoading();
    let ok: () => void;

    this.checkNuumas();

    if (this.new) {
      this.infraService.refreshGlobalStatus();
      ok = () => {
        this.infraService.addOrganizationInfra(this.organization).subscribe((createdOrg) => {
          createdOrg ? this.closeOperation('ORG_ADMIN.ORG_CREATED', loading) : loading.close();
        });
      };
      this.translate.get(['ALERT.CONFIRM-TITLE', 'ALERT.CONFIRM-MESSAGE']).subscribe(values => {
        this.appService.openDialog(values['ALERT.CONFIRM-TITLE'], values['ALERT.CONFIRM-MESSAGE'], ok, () => { loading.close(); });
      });
    } else {
      ok = () => {
        this.infraService.updateOrganizationInfra(this.organization).subscribe((updatedOrg) => {
            if (updatedOrg) {
              this.closeOperation('ORG_ADMIN.ORG_UPDATED', loading);
            } else {
              loading.close();
            }
            this.prepareTemporalUsers();
          });
      };
      this.translate.get(['ALERT.CONFIRM-TITLE', 'ALERT.CONFIRM-MESSAGE']).subscribe(values => {
        this.appService.openDialog(values['ALERT.CONFIRM-TITLE'], values['ALERT.CONFIRM-MESSAGE'], ok, () => { loading.close(); });
      });
    }
  }

  private prepareTemporalUsers() {
    // 1. Quitar los usuarios eliminados
    // 2. Cambiar los usuarios de lista los que han sido cambiados de role
    // 3. Quitar los actions
    
    // 1. 
    this.selectedNuumas = this.selectedNuumas.filter(user => user.action !== 'delete');
    this.organization.admins = this.organization.admins.filter(user => user.action !== 'delete');
    this.organization.users = this.organization.users.filter(user => user.action !== 'delete');

    // 2.
    let adminsChangedRole = this.organization.admins.filter(user => user.action === 'update');
    let usersChangedRole = this.organization.users.filter(user => user.action === 'update');

    adminsChangedRole.forEach(user => {
      // 2.1 Quitar usuario de admin
      let index = this.organization.admins.indexOf(user);
      if (index >= 0) {
        this.organization.admins.splice(index, 1);
      }
      // 2.2. Añadir usuario como usuario reseteando el campo action
      user.action = '';
      this.organization.users.push(user);
    });

    usersChangedRole.forEach(user => {
      // 2.1 Quitar usuario de user
      let index = this.organization.users.indexOf(user);
      if (index >= 0) {
        this.organization.users.splice(index, 1);
      }
      // 2.2. Añadir usuario como admin reseteando el campo action
      user.action = '';
      this.organization.admins.push(user);
    });
    
    // 3
    this.organization.users.forEach(user => user.action = '');
    this.organization.admins.forEach(user => user.action = '');
    this.selectedNuumas.forEach(user => user.action = '');

    let globalOrg = this.infrastructure.organizations.find(org => org.name == this.organization.name);
    globalOrg.admins = this.organization.admins
    globalOrg.users = this.organization.users
    globalOrg.saved = Date.now();
    
    this.disabled = true;
    this.startCounter();
  }

  private closeOperation(title: string, loading) {
    const msg = this.translate.instant(title);
    this.snackBar.open(msg, null, { duration: 5000 });
    this.router.navigate(['/v1/status']);
    loading.close();
  }
}
